function mhProducts(){
    $('.product').each(function () {
        if($(this).hasClass('highlight-product')){
            $(this).attr('class', 'product col-xs-12 col-sm-6 col-md-4');
        }
    })
}


$(document).ready(function() {
    mhProducts()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhProducts()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhProducts();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
   // mhProducts();
});